const footerLinks = [
  {
    title: "Products",
    links: [
      { name: "Payments", href: "/products/payments" },
      { name: "Subscriptions", href: "/products/subscriptions" },
      { name: "Connect", href: "/products/connect" },
      { name: "Radar", href: "/products/radar" },
      { name: "Billing", href: "/products/billing" },
      { name: "Terminal", href: "/products/terminal" },
    ]
  },
  {
    title: "Developers",
    links: [
      { name: "Documentation", href: "/developers/docs" },
      { name: "API Reference", href: "/developers/sdk" },
      { name: "Webhooks", href: "/developers/webhooks" },
      { name: "Status", href: "/status" },
    ]
  },
  {
    title: "Company",
    links: [
      { name: "Blog", href: "/blog" },
      { name: "Partners", href: "/resources/partners" },
      { name: "Contact", href: "/contact" },
      { name: "Security", href: "/security" },
    ]
  },
  {
    title: "Resources",
    links: [
      { name: "Pricing", href: "/pricing" },
      { name: "Case Studies", href: "/resources/case-studies" },
      { name: "Guides", href: "/resources/guides" },
    ]
  }
];

export default function Footer() {
  return (
    <footer style={{ background: "#F5F7FB" }} className="border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        {/* Top: Logo + links */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Logo col */}
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="flex items-center gap-2 mb-4">
              <img
                src="https://static.readdy.ai/image/37f481326fda0879b2d66b8287a2bda5/24804a5b7a84097d49c7147057688146.png"
                alt="Paygent"
                className="w-auto" style={{ height: "168px" }}
              />
            </a>
            <p className="text-sm text-gray-500 leading-relaxed mb-4 max-w-[180px]">
              The intelligent payment gateway for modern businesses.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-twitter-x-line", href: "https://twitter.com/paygent" },
                { icon: "ri-linkedin-line", href: "https://linkedin.com/company/paygent" },
                { icon: "ri-github-line", href: "https://github.com/paygent" },
              ].map((s) => (
                <a key={s.icon} href={s.href}
                  target="_blank" rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-gray-500 hover:text-blue-600 hover:border-blue-200 transition-colors cursor-pointer">
                  <i className={`${s.icon} text-sm w-4 h-4 flex items-center justify-center`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-bold text-gray-900 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <a href={link.href} className="text-sm text-gray-500 hover:text-blue-600 transition-colors cursor-pointer">{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Paygent, Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            {[
              { label: "Privacy Policy", href: "/privacy" },
              { label: "Terms of Service", href: "/terms" },
              { label: "Security", href: "/security" },
              { label: "Cookies", href: "/cookies" },
            ].map((l) => (
              <a key={l.label} href={l.href} className="text-xs text-gray-400 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">{l.label}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
